'use strict';
import cookies from '../helpers/cookies';
var gaTracker = require('../analytics/gaTracker');

function exitPages () {
  const $exitPageModal = $('#exit-page-modal');
  const $exitPageModalCta = $('#exit-page-modal .js-carousel-cta');
  const delay = 5000;
  const sensitivity = 20;
  const isInFrame = window.self !== window.top;
  let isDelayEnded = false;

  if ($exitPageModal.length > 0 && !isInFrame) {
    const exitPageId = $exitPageModal.attr('data-exit-page') || '';

    setTimeout(() => {
      isDelayEnded = true;
    }, delay);

    $(window.document).on('mousemove', event => {
      const cookie = cookies.get(`exit-page-${exitPageId}`);

      if (event.pageY <= sensitivity && isDelayEnded && cookie !== '1') {
        gaTracker('modal', 'triggered', `exit-page-${exitPageId}-open`, null, true);
        $exitPageModal.modal('show');
      }
    });

    $exitPageModal.on('hide.bs.modal', () => {
      gaTracker('modal', 'click', `exit-page-${exitPageId}-close`, null, true);
      cookies.set(`exit-page-${exitPageId}`, 1, 1);
    });

    $exitPageModalCta.on('click', () => {
      gaTracker('modal', 'click', `exit-page-${exitPageId}-cta`, null, true);
    });
  }
}

module.exports = exitPages;
